<div *ngIf="showLabel" class="fx--h fx--label fx--label__nowrap fx--mb-4 fx--label__bold fx--juc-space-between">
  <label class="miq-form-input-label" [attr.for]="filter$().key">{{ filter$().value }}</label>
</div>
<div class="form-field__container">
  <p-multiSelect
    class="primeng-multiselect"
    [options]="options"
    [appendTo]="'body'"
    placeholder="All"
    [disabled]="filter$()?.disabled"
    maxSelectedLabels="1"
    selectedItemsLabel="{0} Selected Items"
    panelStyleClass="filter-multi-select"
    [formControl]="control"
    [resetFilterOnHide]="true"
    [showClear]="hasClearIcon"
    (onChange)="handleChange()"
  >
    <!-- Custom item template: show disabled labels grayed out while keeping checkbox interactive -->
    <ng-template let-option pTemplate="item">
      <span [class.disabled-option-label]="option.disabledLabel">{{ option.label }}</span>
    </ng-template>
    <!--
    As per MIQ-15861 story AC, Display "ALL" option ONLY if there are values selected
    NOTE: TO BE IMPLEMENTED, LEAVING IT AS REMINDER OF MISSING IMPLEMENTATION

      <p-footer *ngIf="currentValue?.length > 0 && displaySeeOthersLink && !filter.multiHideAllLink">
        <a class="see-others" (click)="seeOthers()">{{ seeOthersText }}</a>
      </p-footer>
    -->
    <ng-template pTemplate="clearicon">
      <em class="multiselect-clear pi pi-times-circle" (click)="control.setValue(null)"></em>
    </ng-template>
  </p-multiSelect>
</div>
